/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.26.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as runtime from '../runtime';
import { ChangeOrderCampusCommandToJSON, ChangeOrderDescriptionCommandToJSON, ChangeOrderExtendedDataCommandToJSON, ChangeOrderJobPriorityCommandToJSON, ChangeOrderJobTypeCommandToJSON, ChangeOrderLocationCommandToJSON, ChangeOrderStartDateTimeCommandToJSON, ChangeOrderTargetDateTimeCommandToJSON, ChangeOrderTradeCommandToJSON, CostPartFromJSON, CostPartCreateCommandToJSON, FieldMetadataFromJSON, PerformoTaskFromJSON, WorkorderFromJSON, WorkorderAddSignatureCommandToJSON, WorkorderApproveCommandToJSON, WorkorderAssetFromJSON, WorkorderAssetCreateCommandToJSON, WorkorderCommentCommandToJSON, WorkorderCompleteCommandToJSON, WorkorderCreateCommandToJSON, WorkorderDeleteSignatureCommandToJSON, WorkorderDenyCommandToJSON, WorkorderEditCommandToJSON, WorkorderEntityTransferCommandToJSON, WorkorderPagedCollectionApiResponseFromJSON, WorkorderReassignCommandToJSON, WorkorderSetSubStatusCommandToJSON, WorkorderSurveyCompleteCommandToJSON, } from '../models';
/**
 *
 */
var WorkordersApi = /** @class */ (function (_super) {
    __extends(WorkordersApi, _super);
    function WorkordersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     */
    WorkordersApi.prototype.addAssetToOrderRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/assets",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: WorkorderAssetCreateCommandToJSON(requestParameters.workorderAssetCreateCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderAssetFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.addAssetToOrder = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addAssetToOrderRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.addCommentRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/AddComment",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: WorkorderCommentCommandToJSON(requestParameters.workorderCommentCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.addComment = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addCommentRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.addPartToOrderRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/parts",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: CostPartCreateCommandToJSON(requestParameters.costPartCreateCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return CostPartFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.addPartToOrder = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addPartToOrderRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.addSignatureToWorkorderRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/AddSignature",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: WorkorderAddSignatureCommandToJSON(requestParameters.workorderAddSignatureCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.addSignatureToWorkorder = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addSignatureToWorkorderRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.apiWorkordersWorkorderIdDeleteRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling apiWorkordersWorkorderIdDelete.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.apiWorkordersWorkorderIdDelete = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiWorkordersWorkorderIdDeleteRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.approveOrderRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/approve",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: WorkorderApproveCommandToJSON(requestParameters.workorderApproveCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.approveOrder = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.approveOrderRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.assetOrderHistoryRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.assetId === null || requestParameters.assetId === undefined) {
                            throw new runtime.RequiredError('assetId', 'Required parameter requestParameters.assetId was null or undefined when calling assetOrderHistory.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/AssetHistory/{assetId}".replace("{" + "assetId" + "}", encodeURIComponent(String(requestParameters.assetId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(WorkorderFromJSON); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.assetOrderHistory = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assetOrderHistoryRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.changeCampusRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling changeCampus.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}/ChangeCampus".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: ChangeOrderCampusCommandToJSON(requestParameters.changeOrderCampusCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.changeCampus = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changeCampusRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.changeDescriptionRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling changeDescription.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}/ChangeDescription".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: ChangeOrderDescriptionCommandToJSON(requestParameters.changeOrderDescriptionCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.changeDescription = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changeDescriptionRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.changeExtendedDataRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling changeExtendedData.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}/ChangeExtendedData".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: ChangeOrderExtendedDataCommandToJSON(requestParameters.changeOrderExtendedDataCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.changeExtendedData = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changeExtendedDataRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.changeJobPriorityRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling changeJobPriority.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}/ChangeJobPriority".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: ChangeOrderJobPriorityCommandToJSON(requestParameters.changeOrderJobPriorityCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.changeJobPriority = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changeJobPriorityRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.changeJobTypeRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling changeJobType.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}/ChangeJobType".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: ChangeOrderJobTypeCommandToJSON(requestParameters.changeOrderJobTypeCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.changeJobType = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changeJobTypeRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.changeLocationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling changeLocation.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}/ChangeLocation".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: ChangeOrderLocationCommandToJSON(requestParameters.changeOrderLocationCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.changeLocation = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changeLocationRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.changeStartDateRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling changeStartDate.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}/ChangeStartDate".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: ChangeOrderStartDateTimeCommandToJSON(requestParameters.changeOrderStartDateTimeCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.changeStartDate = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changeStartDateRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.changeTargetDateRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling changeTargetDate.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}/ChangeTargetDate".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: ChangeOrderTargetDateTimeCommandToJSON(requestParameters.changeOrderTargetDateTimeCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.changeTargetDate = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changeTargetDateRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.changeTradeRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling changeTrade.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}/ChangeTrade".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: ChangeOrderTradeCommandToJSON(requestParameters.changeOrderTradeCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.changeTrade = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changeTradeRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.completeOrderRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/complete",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: WorkorderCompleteCommandToJSON(requestParameters.workorderCompleteCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.completeOrder = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.completeOrderRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.completeSurveyRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/CompleteSurvey",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: WorkorderSurveyCompleteCommandToJSON(requestParameters.workorderSurveyCompleteCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.completeSurvey = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.completeSurveyRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.createRequestRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/Request",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: WorkorderCreateCommandToJSON(requestParameters.workorderCreateCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.createRequest = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createRequestRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.createRequestFormDataRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, consumes, canConsumeForm, formParams, useForm, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4:
                        consumes = [
                            { contentType: 'multipart/form-data' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.userId !== undefined) {
                            formParams.append('UserId', requestParameters.userId);
                        }
                        if (requestParameters.fMRecordId !== undefined) {
                            formParams.append('FMRecordId', requestParameters.fMRecordId);
                        }
                        if (requestParameters.fMModId !== undefined) {
                            formParams.append('FMModId', requestParameters.fMModId);
                        }
                        if (requestParameters.createdBy !== undefined) {
                            formParams.append('CreatedBy', requestParameters.createdBy);
                        }
                        if (requestParameters.workorderId !== undefined) {
                            formParams.append('WorkorderId', requestParameters.workorderId);
                        }
                        if (requestParameters.requestId !== undefined) {
                            formParams.append('RequestId', requestParameters.requestId);
                        }
                        if (requestParameters.setId !== undefined) {
                            formParams.append('SetId', requestParameters.setId);
                        }
                        if (requestParameters.pMScheduleId !== undefined) {
                            formParams.append('PMScheduleId', requestParameters.pMScheduleId);
                        }
                        if (requestParameters.contactId !== undefined) {
                            formParams.append('ContactId', requestParameters.contactId);
                        }
                        if (requestParameters.assignToId !== undefined) {
                            formParams.append('AssignToId', requestParameters.assignToId);
                        }
                        if (requestParameters.surveyId !== undefined) {
                            formParams.append('SurveyId', requestParameters.surveyId);
                        }
                        if (requestParameters.assignTo !== undefined) {
                            formParams.append('AssignTo', requestParameters.assignTo);
                        }
                        if (requestParameters.assignToSecondary !== undefined) {
                            formParams.append('AssignToSecondary', requestParameters.assignToSecondary);
                        }
                        if (requestParameters.propertyId !== undefined) {
                            formParams.append('PropertyId', requestParameters.propertyId);
                        }
                        if (requestParameters.campus !== undefined) {
                            formParams.append('Campus', requestParameters.campus);
                        }
                        if (requestParameters.orderBy !== undefined) {
                            formParams.append('OrderBy', requestParameters.orderBy);
                        }
                        if (requestParameters.orderByField2 !== undefined) {
                            formParams.append('OrderByField2', requestParameters.orderByField2);
                        }
                        if (requestParameters.phoneNumber !== undefined) {
                            formParams.append('PhoneNumber', requestParameters.phoneNumber);
                        }
                        if (requestParameters.emailAssignee !== undefined) {
                            formParams.append('EmailAssignee', requestParameters.emailAssignee);
                        }
                        if (requestParameters.emailRequester !== undefined) {
                            formParams.append('EmailRequester', requestParameters.emailRequester);
                        }
                        if (requestParameters.building !== undefined) {
                            formParams.append('Building', requestParameters.building);
                        }
                        if (requestParameters.floor !== undefined) {
                            formParams.append('Floor', requestParameters.floor);
                        }
                        if (requestParameters.suite !== undefined) {
                            formParams.append('Suite', requestParameters.suite);
                        }
                        if (requestParameters.location3 !== undefined) {
                            formParams.append('Location3', requestParameters.location3);
                        }
                        if (requestParameters.jobType !== undefined) {
                            formParams.append('JobType', requestParameters.jobType);
                        }
                        if (requestParameters.trade !== undefined) {
                            formParams.append('Trade', requestParameters.trade);
                        }
                        if (requestParameters.orderStatus !== undefined) {
                            formParams.append('OrderStatus', requestParameters.orderStatus);
                        }
                        if (requestParameters.closedOutFlag !== undefined) {
                            formParams.append('ClosedOutFlag', requestParameters.closedOutFlag);
                        }
                        if (requestParameters.orderCategory !== undefined) {
                            formParams.append('OrderCategory', requestParameters.orderCategory);
                        }
                        if (requestParameters.overdueFlag !== undefined) {
                            formParams.append('OverdueFlag', requestParameters.overdueFlag);
                        }
                        if (requestParameters.completedOrderFlag !== undefined) {
                            formParams.append('CompletedOrderFlag', requestParameters.completedOrderFlag);
                        }
                        if (requestParameters.reqFlag !== undefined) {
                            formParams.append('ReqFlag', requestParameters.reqFlag);
                        }
                        if (requestParameters.openOrderFlag !== undefined) {
                            formParams.append('OpenOrderFlag', requestParameters.openOrderFlag);
                        }
                        if (requestParameters.orderNumber !== undefined) {
                            formParams.append('OrderNumber', requestParameters.orderNumber);
                        }
                        if (requestParameters.jobPriority !== undefined) {
                            formParams.append('JobPriority', requestParameters.jobPriority);
                        }
                        if (requestParameters.description !== undefined) {
                            formParams.append('Description', requestParameters.description);
                        }
                        if (requestParameters.notes !== undefined) {
                            formParams.append('Notes', requestParameters.notes);
                        }
                        if (requestParameters.privateNotes !== undefined) {
                            formParams.append('PrivateNotes', requestParameters.privateNotes);
                        }
                        if (requestParameters.startDateTime !== undefined) {
                            formParams.append('StartDateTime', requestParameters.startDateTime);
                        }
                        if (requestParameters.startDate !== undefined) {
                            formParams.append('StartDate', requestParameters.startDate);
                        }
                        if (requestParameters.startTime !== undefined) {
                            formParams.append('StartTime', requestParameters.startTime);
                        }
                        if (requestParameters.startTimestampLTZ !== undefined) {
                            formParams.append('StartTimestampLTZ', requestParameters.startTimestampLTZ);
                        }
                        if (requestParameters.entryDateTime !== undefined) {
                            formParams.append('EntryDateTime', requestParameters.entryDateTime);
                        }
                        if (requestParameters.entryDate !== undefined) {
                            formParams.append('EntryDate', requestParameters.entryDate);
                        }
                        if (requestParameters.entryTime !== undefined) {
                            formParams.append('EntryTime', requestParameters.entryTime);
                        }
                        if (requestParameters.entryTimestampLTZ !== undefined) {
                            formParams.append('EntryTimestampLTZ', requestParameters.entryTimestampLTZ);
                        }
                        if (requestParameters.entryDateLTZ !== undefined) {
                            formParams.append('EntryDateLTZ', requestParameters.entryDateLTZ);
                        }
                        if (requestParameters.entryTimeLTZ !== undefined) {
                            formParams.append('EntryTimeLTZ', requestParameters.entryTimeLTZ);
                        }
                        if (requestParameters.targetDateTime !== undefined) {
                            formParams.append('TargetDateTime', requestParameters.targetDateTime);
                        }
                        if (requestParameters.targetDate !== undefined) {
                            formParams.append('TargetDate', requestParameters.targetDate);
                        }
                        if (requestParameters.targetTime !== undefined) {
                            formParams.append('TargetTime', requestParameters.targetTime);
                        }
                        if (requestParameters.targetTimestampLTZ !== undefined) {
                            formParams.append('TargetTimestampLTZ', requestParameters.targetTimestampLTZ);
                        }
                        if (requestParameters.completionDateTime !== undefined) {
                            formParams.append('CompletionDateTime', requestParameters.completionDateTime);
                        }
                        if (requestParameters.completionDate !== undefined) {
                            formParams.append('CompletionDate', requestParameters.completionDate);
                        }
                        if (requestParameters.completionTime !== undefined) {
                            formParams.append('CompletionTime', requestParameters.completionTime);
                        }
                        if (requestParameters.completionTimestampLTZ !== undefined) {
                            formParams.append('CompletionTimestampLTZ', requestParameters.completionTimestampLTZ);
                        }
                        if (requestParameters.didNotCompleteDateTime !== undefined) {
                            formParams.append('DidNotCompleteDateTime', requestParameters.didNotCompleteDateTime);
                        }
                        if (requestParameters.didNotCompleteFlag !== undefined) {
                            formParams.append('DidNotCompleteFlag', requestParameters.didNotCompleteFlag);
                        }
                        if (requestParameters.assignedDateTime !== undefined) {
                            formParams.append('AssignedDateTime', requestParameters.assignedDateTime);
                        }
                        if (requestParameters.holdDateTime !== undefined) {
                            formParams.append('HoldDateTime', requestParameters.holdDateTime);
                        }
                        if (requestParameters.holdFlag !== undefined) {
                            formParams.append('HoldFlag', requestParameters.holdFlag);
                        }
                        if (requestParameters.deniedDateTime !== undefined) {
                            formParams.append('DeniedDateTime', requestParameters.deniedDateTime);
                        }
                        if (requestParameters.workorderTimeZone !== undefined) {
                            formParams.append('WorkorderTimeZone', requestParameters.workorderTimeZone);
                        }
                        if (requestParameters.workorderTimeZoneCode !== undefined) {
                            formParams.append('WorkorderTimeZoneCode', requestParameters.workorderTimeZoneCode);
                        }
                        if (requestParameters.workorderTimeZoneDifferenceHours !== undefined) {
                            formParams.append('WorkorderTimeZoneDifferenceHours', requestParameters.workorderTimeZoneDifferenceHours);
                        }
                        if (requestParameters.workorderTimeZoneDifferencial !== undefined) {
                            formParams.append('WorkorderTimeZoneDifferencial', requestParameters.workorderTimeZoneDifferencial);
                        }
                        if (requestParameters.log) {
                            formParams.append('Log', requestParameters.log.join(runtime.COLLECTION_FORMATS["csv"]));
                        }
                        if (requestParameters.assets) {
                            formParams.append('Assets', requestParameters.assets.join(runtime.COLLECTION_FORMATS["csv"]));
                        }
                        if (requestParameters.costParts) {
                            formParams.append('CostParts', requestParameters.costParts.join(runtime.COLLECTION_FORMATS["csv"]));
                        }
                        if (requestParameters.costLabor) {
                            formParams.append('CostLabor', requestParameters.costLabor.join(runtime.COLLECTION_FORMATS["csv"]));
                        }
                        if (requestParameters.procedureName !== undefined) {
                            formParams.append('ProcedureName', requestParameters.procedureName);
                        }
                        if (requestParameters.procedureText !== undefined) {
                            formParams.append('ProcedureText', requestParameters.procedureText);
                        }
                        if (requestParameters.procedureMandatoryFlag !== undefined) {
                            formParams.append('ProcedureMandatoryFlag', requestParameters.procedureMandatoryFlag);
                        }
                        if (requestParameters.unprocessedFailedTasksFlag !== undefined) {
                            formParams.append('UnprocessedFailedTasksFlag', requestParameters.unprocessedFailedTasksFlag);
                        }
                        if (requestParameters.latitude !== undefined) {
                            formParams.append('Latitude', requestParameters.latitude);
                        }
                        if (requestParameters.longitude !== undefined) {
                            formParams.append('Longitude', requestParameters.longitude);
                        }
                        if (requestParameters.gPS !== undefined) {
                            formParams.append('GPS', requestParameters.gPS);
                        }
                        if (requestParameters.tasks) {
                            formParams.append('Tasks', requestParameters.tasks.join(runtime.COLLECTION_FORMATS["csv"]));
                        }
                        if (requestParameters.photos) {
                            formParams.append('Photos', requestParameters.photos.join(runtime.COLLECTION_FORMATS["csv"]));
                        }
                        if (requestParameters.documents) {
                            formParams.append('Documents', requestParameters.documents.join(runtime.COLLECTION_FORMATS["csv"]));
                        }
                        if (requestParameters.multiAssetDisplay !== undefined) {
                            formParams.append('MultiAssetDisplay', requestParameters.multiAssetDisplay);
                        }
                        if (requestParameters.signatureUrl !== undefined) {
                            formParams.append('SignatureUrl', requestParameters.signatureUrl);
                        }
                        if (requestParameters.signature !== undefined) {
                            formParams.append('Signature', requestParameters.signature);
                        }
                        if (requestParameters.billableTo !== undefined) {
                            formParams.append('BillableTo', requestParameters.billableTo);
                        }
                        if (requestParameters.billableCategory !== undefined) {
                            formParams.append('BillableCategory', requestParameters.billableCategory);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/api/Workorders/RequestFormData",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.createRequestFormData = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createRequestFormDataRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.createWorkOrderRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: WorkorderCreateCommandToJSON(requestParameters.workorderCreateCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.createWorkOrder = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createWorkOrderRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.deleteSignatureOnWorkorderRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/DeleteSignature",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: WorkorderDeleteSignatureCommandToJSON(requestParameters.workorderDeleteSignatureCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.deleteSignatureOnWorkorder = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteSignatureOnWorkorderRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.deleteWorkOrderCostPartRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling deleteWorkOrderCostPart.');
                        }
                        if (requestParameters.costId === null || requestParameters.costId === undefined) {
                            throw new runtime.RequiredError('costId', 'Required parameter requestParameters.costId was null or undefined when calling deleteWorkOrderCostPart.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}/costpart/{costId}".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))).replace("{" + "costId" + "}", encodeURIComponent(String(requestParameters.costId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.deleteWorkOrderCostPart = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteWorkOrderCostPartRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.denyOrderRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/deny",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: WorkorderDenyCommandToJSON(requestParameters.workorderDenyCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.denyOrder = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.denyOrderRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.duplicateWorkOrderRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling duplicateWorkOrder.');
                        }
                        if (requestParameters.assignTo === null || requestParameters.assignTo === undefined) {
                            throw new runtime.RequiredError('assignTo', 'Required parameter requestParameters.assignTo was null or undefined when calling duplicateWorkOrder.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/duplicate/{workorderId}/{assignTo}".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))).replace("{" + "assignTo" + "}", encodeURIComponent(String(requestParameters.assignTo))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.duplicateWorkOrder = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.duplicateWorkOrderRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.editWorkOrderRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling editWorkOrder.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: WorkorderEditCommandToJSON(requestParameters.workorderEditCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.editWorkOrder = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.editWorkOrderRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.getCustomFieldsRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/getCustomFields",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(FieldMetadataFromJSON); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.getCustomFields = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomFieldsRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.getSignatureByOrderIdRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling getSignatureByOrderId.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{orderId}/signature".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.getSignatureByOrderId = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSignatureByOrderIdRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.getWorkOrderRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling getWorkOrder.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.getWorkOrder = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getWorkOrderRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.getWorkorderAssetRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling getWorkorderAsset.');
                        }
                        if (requestParameters.orderAssetId === null || requestParameters.orderAssetId === undefined) {
                            throw new runtime.RequiredError('orderAssetId', 'Required parameter requestParameters.orderAssetId was null or undefined when calling getWorkorderAsset.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}/assets/{orderAssetId}".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))).replace("{" + "orderAssetId" + "}", encodeURIComponent(String(requestParameters.orderAssetId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderAssetFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.getWorkorderAsset = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getWorkorderAssetRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.openOrderRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling openOrder.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}/open-order".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.openOrder = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.openOrderRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.queryWorkOrdersRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.sortColumn !== undefined) {
                            queryParameters['SortColumn'] = requestParameters.sortColumn;
                        }
                        if (requestParameters.sortDirection !== undefined) {
                            queryParameters['SortDirection'] = requestParameters.sortDirection;
                        }
                        if (requestParameters.skip !== undefined) {
                            queryParameters['Skip'] = requestParameters.skip;
                        }
                        if (requestParameters.take !== undefined) {
                            queryParameters['Take'] = requestParameters.take;
                        }
                        if (requestParameters.omit !== undefined) {
                            queryParameters['Omit'] = requestParameters.omit;
                        }
                        if (requestParameters.propertyId !== undefined) {
                            queryParameters['PropertyId'] = requestParameters.propertyId;
                        }
                        if (requestParameters.campus !== undefined) {
                            queryParameters['Campus'] = requestParameters.campus;
                        }
                        if (requestParameters.building !== undefined) {
                            queryParameters['Building'] = requestParameters.building;
                        }
                        if (requestParameters.suite !== undefined) {
                            queryParameters['Suite'] = requestParameters.suite;
                        }
                        if (requestParameters.floor !== undefined) {
                            queryParameters['Floor'] = requestParameters.floor;
                        }
                        if (requestParameters.orderNumber !== undefined) {
                            queryParameters['OrderNumber'] = requestParameters.orderNumber;
                        }
                        if (requestParameters.requestId !== undefined) {
                            queryParameters['RequestId'] = requestParameters.requestId;
                        }
                        if (requestParameters.orderStatus !== undefined) {
                            queryParameters['OrderStatus'] = requestParameters.orderStatus;
                        }
                        if (requestParameters.overdueFlag !== undefined) {
                            queryParameters['OverdueFlag'] = requestParameters.overdueFlag;
                        }
                        if (requestParameters.workorderId !== undefined) {
                            queryParameters['WorkorderId'] = requestParameters.workorderId;
                        }
                        if (requestParameters.orderCategory !== undefined) {
                            queryParameters['OrderCategory'] = requestParameters.orderCategory;
                        }
                        if (requestParameters.jobType !== undefined) {
                            queryParameters['JobType'] = requestParameters.jobType;
                        }
                        if (requestParameters.trade !== undefined) {
                            queryParameters['Trade'] = requestParameters.trade;
                        }
                        if (requestParameters.entryDateStart !== undefined) {
                            queryParameters['EntryDateStart'] = requestParameters.entryDateStart.toISOString();
                        }
                        if (requestParameters.entryDateEnd !== undefined) {
                            queryParameters['EntryDateEnd'] = requestParameters.entryDateEnd.toISOString();
                        }
                        if (requestParameters.startDateStart !== undefined) {
                            queryParameters['StartDateStart'] = requestParameters.startDateStart.toISOString();
                        }
                        if (requestParameters.startDateEnd !== undefined) {
                            queryParameters['StartDateEnd'] = requestParameters.startDateEnd.toISOString();
                        }
                        if (requestParameters.completionDateStart !== undefined) {
                            queryParameters['CompletionDateStart'] = requestParameters.completionDateStart.toISOString();
                        }
                        if (requestParameters.completionDateEnd !== undefined) {
                            queryParameters['CompletionDateEnd'] = requestParameters.completionDateEnd.toISOString();
                        }
                        if (requestParameters.contactId !== undefined) {
                            queryParameters['ContactId'] = requestParameters.contactId;
                        }
                        if (requestParameters.assignTo !== undefined) {
                            queryParameters['AssignTo'] = requestParameters.assignTo;
                        }
                        if (requestParameters.jobPriority !== undefined) {
                            queryParameters['JobPriority'] = requestParameters.jobPriority;
                        }
                        if (requestParameters.setId !== undefined) {
                            queryParameters['SetId'] = requestParameters.setId;
                        }
                        if (requestParameters.includeSubStatuses !== undefined) {
                            queryParameters['IncludeSubStatuses'] = requestParameters.includeSubStatuses;
                        }
                        if (requestParameters.multiAssetDisplay !== undefined) {
                            queryParameters['MultiAssetDisplay'] = requestParameters.multiAssetDisplay;
                        }
                        if (requestParameters.orderBy !== undefined) {
                            queryParameters['OrderBy'] = requestParameters.orderBy;
                        }
                        if (requestParameters.orderByField2 !== undefined) {
                            queryParameters['OrderByField2'] = requestParameters.orderByField2;
                        }
                        if (requestParameters.isViewAllRequestersOrdersChecked !== undefined) {
                            queryParameters['IsViewAllRequestersOrdersChecked'] = requestParameters.isViewAllRequestersOrdersChecked;
                        }
                        if (requestParameters.description !== undefined) {
                            queryParameters['Description'] = requestParameters.description;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderPagedCollectionApiResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.queryWorkOrders = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queryWorkOrdersRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.queryWorkOrdersAsExcelRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.sortColumn !== undefined) {
                            queryParameters['SortColumn'] = requestParameters.sortColumn;
                        }
                        if (requestParameters.sortDirection !== undefined) {
                            queryParameters['SortDirection'] = requestParameters.sortDirection;
                        }
                        if (requestParameters.skip !== undefined) {
                            queryParameters['Skip'] = requestParameters.skip;
                        }
                        if (requestParameters.take !== undefined) {
                            queryParameters['Take'] = requestParameters.take;
                        }
                        if (requestParameters.omit !== undefined) {
                            queryParameters['Omit'] = requestParameters.omit;
                        }
                        if (requestParameters.propertyId !== undefined) {
                            queryParameters['PropertyId'] = requestParameters.propertyId;
                        }
                        if (requestParameters.campus !== undefined) {
                            queryParameters['Campus'] = requestParameters.campus;
                        }
                        if (requestParameters.building !== undefined) {
                            queryParameters['Building'] = requestParameters.building;
                        }
                        if (requestParameters.suite !== undefined) {
                            queryParameters['Suite'] = requestParameters.suite;
                        }
                        if (requestParameters.floor !== undefined) {
                            queryParameters['Floor'] = requestParameters.floor;
                        }
                        if (requestParameters.orderNumber !== undefined) {
                            queryParameters['OrderNumber'] = requestParameters.orderNumber;
                        }
                        if (requestParameters.requestId !== undefined) {
                            queryParameters['RequestId'] = requestParameters.requestId;
                        }
                        if (requestParameters.orderStatus !== undefined) {
                            queryParameters['OrderStatus'] = requestParameters.orderStatus;
                        }
                        if (requestParameters.overdueFlag !== undefined) {
                            queryParameters['OverdueFlag'] = requestParameters.overdueFlag;
                        }
                        if (requestParameters.workorderId !== undefined) {
                            queryParameters['WorkorderId'] = requestParameters.workorderId;
                        }
                        if (requestParameters.orderCategory !== undefined) {
                            queryParameters['OrderCategory'] = requestParameters.orderCategory;
                        }
                        if (requestParameters.jobType !== undefined) {
                            queryParameters['JobType'] = requestParameters.jobType;
                        }
                        if (requestParameters.trade !== undefined) {
                            queryParameters['Trade'] = requestParameters.trade;
                        }
                        if (requestParameters.entryDateStart !== undefined) {
                            queryParameters['EntryDateStart'] = requestParameters.entryDateStart.toISOString();
                        }
                        if (requestParameters.entryDateEnd !== undefined) {
                            queryParameters['EntryDateEnd'] = requestParameters.entryDateEnd.toISOString();
                        }
                        if (requestParameters.startDateStart !== undefined) {
                            queryParameters['StartDateStart'] = requestParameters.startDateStart.toISOString();
                        }
                        if (requestParameters.startDateEnd !== undefined) {
                            queryParameters['StartDateEnd'] = requestParameters.startDateEnd.toISOString();
                        }
                        if (requestParameters.completionDateStart !== undefined) {
                            queryParameters['CompletionDateStart'] = requestParameters.completionDateStart.toISOString();
                        }
                        if (requestParameters.completionDateEnd !== undefined) {
                            queryParameters['CompletionDateEnd'] = requestParameters.completionDateEnd.toISOString();
                        }
                        if (requestParameters.contactId !== undefined) {
                            queryParameters['ContactId'] = requestParameters.contactId;
                        }
                        if (requestParameters.assignTo !== undefined) {
                            queryParameters['AssignTo'] = requestParameters.assignTo;
                        }
                        if (requestParameters.jobPriority !== undefined) {
                            queryParameters['JobPriority'] = requestParameters.jobPriority;
                        }
                        if (requestParameters.setId !== undefined) {
                            queryParameters['SetId'] = requestParameters.setId;
                        }
                        if (requestParameters.includeSubStatuses !== undefined) {
                            queryParameters['IncludeSubStatuses'] = requestParameters.includeSubStatuses;
                        }
                        if (requestParameters.multiAssetDisplay !== undefined) {
                            queryParameters['MultiAssetDisplay'] = requestParameters.multiAssetDisplay;
                        }
                        if (requestParameters.orderBy !== undefined) {
                            queryParameters['OrderBy'] = requestParameters.orderBy;
                        }
                        if (requestParameters.orderByField2 !== undefined) {
                            queryParameters['OrderByField2'] = requestParameters.orderByField2;
                        }
                        if (requestParameters.isViewAllRequestersOrdersChecked !== undefined) {
                            queryParameters['IsViewAllRequestersOrdersChecked'] = requestParameters.isViewAllRequestersOrdersChecked;
                        }
                        if (requestParameters.description !== undefined) {
                            queryParameters['Description'] = requestParameters.description;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/as-excel",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.queryWorkOrdersAsExcel = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queryWorkOrdersAsExcelRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.reassignOrderToRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/reassign",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: WorkorderReassignCommandToJSON(requestParameters.workorderReassignCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.reassignOrderTo = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.reassignOrderToRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.setDNCRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling setDNC.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}/set-dnc".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.setDNC = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setDNCRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.setHoldRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling setHold.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}/set-hold".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.setHold = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setHoldRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.setSubStatusRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/SetSubStatus",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: WorkorderSetSubStatusCommandToJSON(requestParameters.workorderSetSubStatusCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.setSubStatus = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setSubStatusRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.transferToRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/TransferTo",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: WorkorderEntityTransferCommandToJSON(requestParameters.workorderEntityTransferCommand),
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return WorkorderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.transferTo = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.transferToRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.updateWorkOrderCostPartQuantityRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling updateWorkOrderCostPartQuantity.');
                        }
                        if (requestParameters.costId === null || requestParameters.costId === undefined) {
                            throw new runtime.RequiredError('costId', 'Required parameter requestParameters.costId was null or undefined when calling updateWorkOrderCostPartQuantity.');
                        }
                        queryParameters = {};
                        if (requestParameters.quantity !== undefined) {
                            queryParameters['quantity'] = requestParameters.quantity;
                        }
                        if (requestParameters.quantityWanted !== undefined) {
                            queryParameters['quantityWanted'] = requestParameters.quantityWanted;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}/costpart/{costId}".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))).replace("{" + "costId" + "}", encodeURIComponent(String(requestParameters.costId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return CostPartFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.updateWorkOrderCostPartQuantity = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateWorkOrderCostPartQuantityRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.workorderTaskDataEntryRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling workorderTaskDataEntry.');
                        }
                        if (requestParameters.taskId === null || requestParameters.taskId === undefined) {
                            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling workorderTaskDataEntry.');
                        }
                        queryParameters = {};
                        if (requestParameters.dataEntry !== undefined) {
                            queryParameters['dataEntry'] = requestParameters.dataEntry;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}/tasks/{taskId}/DataEntry".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))).replace("{" + "taskId" + "}", encodeURIComponent(String(requestParameters.taskId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PerformoTaskFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.workorderTaskDataEntry = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.workorderTaskDataEntryRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.workorderTaskDoneRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling workorderTaskDone.');
                        }
                        if (requestParameters.taskId === null || requestParameters.taskId === undefined) {
                            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling workorderTaskDone.');
                        }
                        queryParameters = {};
                        if (requestParameters.doneFlag !== undefined) {
                            queryParameters['doneFlag'] = requestParameters.doneFlag;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}/tasks/{taskId}/WorkorderTaskDone".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))).replace("{" + "taskId" + "}", encodeURIComponent(String(requestParameters.taskId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PerformoTaskFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.workorderTaskDone = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.workorderTaskDoneRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.workorderTaskFailedRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.workorderId === null || requestParameters.workorderId === undefined) {
                            throw new runtime.RequiredError('workorderId', 'Required parameter requestParameters.workorderId was null or undefined when calling workorderTaskFailed.');
                        }
                        if (requestParameters.taskId === null || requestParameters.taskId === undefined) {
                            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling workorderTaskFailed.');
                        }
                        queryParameters = {};
                        if (requestParameters.failedFlag !== undefined) {
                            queryParameters['failedFlag'] = requestParameters.failedFlag;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Workorders/{workorderId}/tasks/{taskId}/WorkorderTaskFailed".replace("{" + "workorderId" + "}", encodeURIComponent(String(requestParameters.workorderId))).replace("{" + "taskId" + "}", encodeURIComponent(String(requestParameters.taskId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PerformoTaskFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    WorkordersApi.prototype.workorderTaskFailed = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.workorderTaskFailedRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return WorkordersApi;
}(runtime.BaseAPI));
export { WorkordersApi };
